<template>
  <div>
    <el-dialog v-if="dialogVisible" v-el-drag-dialog title="会议议程" :visible.sync="dialogVisible" width="1100px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
      <div>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 10px;">
            <el-tabs v-model="activeName" class="ytml_info_tabs" @tab-click="handleClick">
                <el-tab-pane label="会议信息" name="first"></el-tab-pane>
                <el-tab-pane :label="'会议议程（'+tableData.length+'）'" name="second"></el-tab-pane>
            </el-tabs>
            <div v-if="activeName=='second'">
                <el-button size="small" @click="addClick">新增</el-button>
                <el-button size="small" @click="selectClick">选择议题</el-button>
            </div>
        </div>
        <div v-loading="loading" :style="{'min-height':loading?'200px':''}">
            <template v-if="activeName=='first'">
                <el-form ref="meetDirectoryForm" :model="vo">
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_会议主题" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'subject'" class="field">会议主题</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <!-- <form-item ref="subject" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入会议主题','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'会议主题','propName':'subject','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.subject','option':[],'autocomplete':'off','showWordLimit':false,'dialog':1,'dialogType':'listpage','dialogOrgLevel':'','dialogListviewurl':'hygl.meetDirectory.list'}" :vo="vo" :can-edit="canEdit" /> -->
                                    <form-item ref="subject" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入会议主题','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'会议主题','propName':'subject','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.subject','option':[],'autocomplete':'off','showWordLimit':false,'dialog':0,'dialogType':'','':'','dialogListviewurl':''}" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_会议类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'subjectTypeName'" class="field">会议类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="subjectTypeName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入会议类型','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'会议主题','propName':'subjectTypeName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.subjectTypeName','option':[],'autocomplete':'off','showWordLimit':false,'dialog':0,'dialogType':'','':'','dialogListviewurl':''}" :vo="vo" :can-edit="0" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_会议期数" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'sessionNumber'" class="field">会议期数</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <div style="display: flex;">
                                        <div style="width: 40px;text-align: center;">第</div>
                                        <div>
                                            <form-item ref="sessionNumber" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入会议期数','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'会议主题','propName':'sessionNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.sessionNumber','option':[],'autocomplete':'off','showWordLimit':false,'dialog':0,'dialogType':'','':'','dialogListviewurl':''}" :vo="vo" :can-edit="canEdit" />
                                        </div>
                                        <div style="width: 40px;text-align: center;">期</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_备注" class="el-table__cell tdlbl tdw17" colspan="1">

                                    <span v-field-lbl="'remark'" class="field">备注</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item ref="remark" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'textarea','emptyMessage':'请输入备注','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'备注','propName':'remark','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.remark','option':[]}" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </el-form>
            </template>
            <template v-if="activeName=='second'">
                 <el-table v-if="isTableShow" border :data="tableData" class="draggable-table" style="margin-bottom: 20px; border-bottom: 1px solid #ebeef5">
                    <el-table-column :label="'序号'" align="center" width="50" type="index" />
                    <el-table-column :label="'排序'" prop="userName" width="80" align="center">
                        <template slot-scope="scope">
                            <div style="display: flex;justify-content: center;" class="handle"><i style="font-size: 18px;" class="el-icon-rank"></i> {{ $tx('hygl.hyyt.move') }} </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="'会议议题'" prop="subject" align="left" :show-overflow-tooltip="true" />
                    <el-table-column :label="'主办部门'" prop="mainDept" align="center" width="150" :show-overflow-tooltip="true" />
                    <el-table-column :label="'陈述人'" prop="reportPersonName" width="120" align="center" :show-overflow-tooltip="true" />
                    <el-table-column :label="'陈述时间/分钟'" prop="reportTime" width="150" align="center" :show-overflow-tooltip="true" />
                    <el-table-column :label="'谈论时间/分钟'" prop="talkTime" width="150" align="center" :show-overflow-tooltip="true" />
                    <!-- <el-table-column :label="'附件'" prop="phone" width="90" align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <div>{{ scope.row.passenger.attachments.length }}</div>
                        </template>
                    </el-table-column> -->
                    <el-table-column :label="'操作'" prop="phone" width="100" align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary" @click="editClick(scope.row, scope.$index)">编辑</el-link>
                            <el-link :underline="false" type="primary" @click="deleteClick(scope.row, scope.$index)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button icon="el-icon-colse" @click="toClose">{{ $tx('hygl.ytRecord.cancel','取消') }}</el-button>
        <el-button type="primary" icon="el-icon-check" @click="submitHandle">生成</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="dialogSelectVisible" v-el-drag-dialog title="选择议题" :visible.sync="dialogSelectVisible" width="1100px" :close-on-click-modal="false">
      <div v-loading="ytLoading" class="home" :style="{'min-height':ytLoading?'180px':''}">
        <div class="dialog_top" style="margin-bottom: 10px">
            <!-- <el-select v-model="searchObj.subjectTypeName" style="margin-right: 15px" size="small" :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')">
                <el-option v-for="item in typeOptions" :key="item.id" :label="item.typeName" :value="item.typeName"></el-option>
            </el-select> -->
            <el-input v-model="searchObj.subject" style="width: 250px" placeholder="请输入" size="small" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="searchHandle"></el-button>
            </el-input>
        </div>
        <el-table :data="ytRecordData" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"> </el-table-column>
          <el-table-column type="index" :label="$tx('hygl.hyyt.index','序号')" width="50" align="center"> </el-table-column>
          <el-table-column prop="subject" :label="$tx('hygl.hyyt.meetingAgenda','会议议题')" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="mainDept" :label="$tx('hygl.hyyt.hostDepartment','主办部门')" :show-overflow-tooltip="true" width="100" align="center"></el-table-column>
          <el-table-column prop="reportPersonName" :label="$tx('hygl.hyyt.declarant','陈述人')" :show-overflow-tooltip="true" width="90" align="center"></el-table-column>
          <el-table-column prop="reportTime" :label="$tx('hygl.hyyt.csTime','陈述时间/分钟')" :show-overflow-tooltip="true" width="110" align="center"></el-table-column>
          <el-table-column prop="talkTime" :label="$tx('hygl.hyyt.talkTime','讨论时间/分钟')" :show-overflow-tooltip="true" width="110" align="center"></el-table-column>
          <el-table-column prop="createDate" :label="$tx('hygl.hyyt.createDate','创建时间')" :show-overflow-tooltip="true" width="150" align="center"> </el-table-column>
        </el-table>
         <div style="text-align: right;margin-top: 10px;">
            <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="ytRecorTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'cancel'" icon="el-icon-colse" @click="dialogSelectVisible = false">关 闭</el-button>
        <el-button v-pageBtn-lbl="'sure'" type="primary" icon="el-icon-check" @click="saveYtRecord">保 存</el-button>
      </span>
    </el-dialog>
     <Basicform
        v-if="showForm"
        :title="title"
        :win-width="moduleInfo.winWidth"
        :win-height="moduleInfo.winHeight"
        :module-code="moduleInfo.moduleCode"
        :append-to-body="true"
        :toolbar-btns="busiformBtns"
        :on-basic-form-before-open="onBasicFormBeforeOpen"
        :on-basic-form-opened="onBasicFormOpened"
        :on-basic-form-before-submit="onBasicFormBeforeSubmit"
        :on-basic-form-submited="onBasicFormSubmited"
        >
      <template #default="slotProps">
        <busi-form ref="ytk" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
      </template>
    </Basicform>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return val ? moment(val).format('YYYY-MM-DD HH:mm') : ''
        }
    },
    components: {},
    props: {},
    data() {
        return {
            title: '',
            dialogVisible: false,
            showForm: false,
            isTableShow: true,
            activeName: 'first',
            loading: true,
            tableData: [],
            loginUser: this.$store.getters.loginUser,
            vo: {},
            canEdit: 1,
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html',
                'winWidth': 1300,
                'delUrl': '/hygl/ytRecord/delete',
                'addNewUrl': '/hygl/ytRecord/addNew',
                'insertUrl': '/hygl/ytRecord/insert',
                'moduleCode': 'budgetKpi',
                'winHeight': 600,
                'updateUrl': '/hygl/ytRecord/update',
                'listDataUrl': '/hygl/ytRecord/listdata',
                'getByIdUrl': '/hygl/ytRecord/getById'
            },
            dialogSelectVisible: false,
            ytLoading: true,
            ytRecordData: [],
            ytRecordSelect: [],
            pageSize: 10,
            currentPage: 1,
            ytRecorTotal: 0,
            typeOptions: [],
            searchObj: {
                subject: '',
                subjectTypeName: ''
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openCreateYtmlDialog', this.openCreateYtmlDialog)
    },
    beforeDestroy() {
        this.$bus.off('openCreateYtmlDialog', this.openCreateYtmlDialog)
    },
    mounted() {},
    methods: {
        openCreateYtmlDialog(list) {
            console.log('list==', list)
            this.searchObj.subjectTypeName = list[0].subjectTypeName
            this.tableData = list
            this.dialogVisible = true
            this.getMeetDirectory()
            // this.getType()
        },
        getMeetDirectory() {
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `hygl/meetDirectory/addNew`,
                method: 'POST'
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo = res.body.vo
                    this.vo.subjectTypeName = this.tableData[0].subjectTypeName
                    this.vo.subjectType = this.tableData[0].subjectType
                }
                this.loading = false
            })
        },
        // 生成
        submitHandle() {
            const _this = this
            if (this.activeName === 'second') {
                if (!this.tableData.length) {
                    this.$alert('请选择议题。', '操作提示', { type: 'warning' })
                    return
                }
            }
            if (!this.vo.subject) {
                this.activeName = 'first'

                setTimeout(() => {
                    this.$refs.meetDirectoryForm.formValidate(async() => {

                    }, null, 1)
                }, 10)
                return
            }
            this.formValidate(async() => {
                const ids = this.tableData.map(item => item.id).join(',')
                _this.vo.passenger.ytRecordIds = ids
                // _this.vo.subjectTypeName = _this.searchObj.subjectTypeName
                // _this.vo.subjectType = _this.searchObj.subjectTypeName
                const res = await this.$app.insert('hygl/meetDirectory/generateMeetDirectory', _this.vo)
                if (res.code === 'success') {
                    _this.$message.success('保存成功。')
                    _this.toClose()
                    _this.$bus.emit('refreshListData')
                }
            }, null, 1)
        },
        // 新增
        addClick() {
            const _this = this
            this.title = '新增议题'
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.moduleInfo.typeName = this.searchObj.subjectTypeName
            this.moduleInfo.isNew = true
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                { id: 'btn_close', btnName: '关 闭', btnIcon: 'close', btnClick: 'closeDialog', btnPermission: '', btnType: '', btnI18nCode: 'close'},
                { id: 'btn_save', btnName: '保 存', btnIcon: 'check', btnClick: this.saveFormData, btnPermission: 'saveObject', btnType: 'primary', btnI18nCode: 'save'}
            ]
            this.showForm = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1, null)
            })
        },
        // 修改
        editClick(row, index) {
            const _this = this
            this.title = '修改议题'
            this.moduleInfo.typeName = this.searchObj.subjectTypeName
            this.moduleInfo.isNew = false
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                { id: 'btn_close', btnName: '关 闭', btnIcon: 'close', btnClick: 'closeDialog', btnPermission: '', btnType: '', btnI18nCode: 'close'},
                { id: 'btn_save', btnName: '保 存', btnIcon: 'check', btnClick: this.saveFormData, btnPermission: 'saveObject', btnType: 'primary', btnI18nCode: 'save'}
            ]
            this.showForm = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, row, 1, null)
            })
        },
        selectClick() {
            this.dialogSelectVisible = true
            this.getyTRecordList()
        },
        deleteClick(row, index) {
            this.tableData.splice(index, 1)
        },
        async getyTRecordList() {
            var ids = ''
            if (this.tableData.length) {
                ids = this.tableData.map(item => item.id).join(',')
            }
            const param = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                listpageViewUrl: 'hygl.ytRecord.list.vue',
                urlsearch: `id!:${ids};status:0`
            }
            if (this.searchObj.subject) {
                param.urlsearch += `;subject like ${this.searchObj.subject}`
            }
            if (this.searchObj.subjectTypeName) {
                param.urlsearch += `;subjectTypeName:${this.searchObj.subjectTypeName}`
            }
            this.ytLoading = true
            const res = await this.$app.listdata('/hygl/ytRecord/listdata', param)
            if (res.code === 'success') {
                this.ytRecordData = res.body.pageInfo.list
                this.ytRecorTotal = res.body.pageInfo.total
                this.ytLoading = false
            }
        },
        searchHandle() {
            this.getyTRecordList()
        },
        saveYtRecord() {
            const _this = this
            if (!this.ytRecordSelect.length) {
                this.$alert('请选择议题。', '操作提示', { type: 'warning' })
                return
            }
            this.tableData.push(...this.ytRecordSelect)
            this.dialogSelectVisible = false
        },
        saveFormData() {
            console.log('this', this)
            const _this = this
            this.formValidate(async () => {
                const vo = _this.$refs.ytk.vo
                const isnew = _this.$refs.ytk.moduleInfo.isNew
                if (isnew) {
                    const res = await this.$app.insert(_this.moduleInfo.insertUrl, vo)
                    if (res.code === 'success') {
                        this.tableData.push(vo)
                    }
                    this.showForm = false
                } else {
                    const index = this.tableData.findIndex(item => item.id === vo.id)
                    const res = await this.$app.update(_this.moduleInfo.updateUrl, vo)
                    if (res.code === 'success') {
                        this.tableData.splice(index, 1, vo)
                    }
                    this.showForm = false
                }
            }, null, 1)
        },
        handleClick(val) {
            console.log(val.name)
            if (val.name === 'first') {
                //
            } else if (val.name === 'second') {
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.register()
                    })
                }, 100)
            }
        },
        handleSelectionChange(val) {
            this.ytRecordSelect = val
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getyTRecordList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getyTRecordList()
        },
        async getType() {
            const param = {
                pageNum: 1,
                pageSize: 999,
                urlsearch: `status:1`
            }
            const res = await this.$app.listdata('/hygl/type/listdata', param)
            if (res.code === 'success') {
                this.typeOptions = res.body.pageInfo.list
                if (this.typeOptions.length) {
                    this.searchObj.subjectTypeName = this.typeOptions[0].typeName
                }
            }
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
            this.dialogSelectVisible = false
            this.tableData = []
            this.ytRecordData = []
            this.ytRecordSelect = []
            this.searchObj = {
                subject: '',
                subjectTypeName: ''
            }
            this.pageSize = 10
            this.currentPage = 1
        },
        /**
        * 表单打开检查，vo为已加载salary对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
        */
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            if (vo.isnew) {
                $scope.title = '新增议题'
            } else {
                $scope.title = '会议议题'
            }
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的salary对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
        */
        onBasicFormOpened: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('salary form opened')
        },
        /**
         * 表单提交事件，可执行业务数据高级校验，vo为待提交的salary对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
         */
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('salary form submit validation success')
            defer.resolve(true)
        },
        /**
        * 表单提交完成，vo为已保存成功的salary对象，窗口即将关闭，不需要返回值
        */
        onBasicFormSubmited: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') {
                console.log('salary form submited ==  $scope', $scope)
                console.log('salary form submited ===  vo', vo)
            }
        },
        onSelectListpageRowCompleted(node, attr) {
            // this.vo.subject = node[0].subject
            // this.vo.createDate = node[0].createDate
            // this.vo.createDept = node[0].createDept
            // this.vo.creatorId = node[0].creatorId
            // this.vo.creatorPhone = node[0].creatorPhone
            // this.vo.orgCode = node[0].orgCode
            // this.vo.orgFullId = node[0].orgFullId
            // this.vo.orgName = node[0].orgName
            // this.vo.status = node[0].status
            // this.vo.id = node[0].id
            console.log(attr)
        },
        // 通用列表选择对话框-加载数据前回调
        onDialogListDataBeforeLoad($scope, qparams) {
            console.log($scope.moduleInfo.moduleCode, 'onDialogListDataBeforeLoad')
            // qparams.urlsearch = `subjectTypeName:${this.tableData[0].subjectTypeName}`
        },
        // 通用列表选择对话框-加载数据后回调
        onDialogListDataLoaded($scope, pageInfo) {
            console.log($scope.moduleInfo.moduleCode, 'onDialogListDataLoaded')
            // pageInfo.list.forEach(item => {
            //     item.noMeetProportion = item.passenger.noMeetProportion
            // })
        },
        register() {
            const _this = this
            const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
            console.log('tbody', tbody)

            new Sortable(tbody, {
                handle: '.handle', // handle's class
                animation: 150,
                // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                onEnd: ({ newIndex, oldIndex }) => {
                    this.isTableShow = false
                    console.log('newIndex', newIndex)
                    console.log('oldIndex', oldIndex)
                    const targetRow = this.tableData[oldIndex]
                    this.tableData.splice(oldIndex, 1)
                    this.tableData.splice(newIndex, 0, targetRow)
                    console.table(this.tableData)
                    this.$nextTick(() => {
                        this.$forceUpdate()
                        this.isTableShow = true
                        this.$nextTick(() => {
                            _this.register()
                        })
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.table_data .el-table::before {
    background-color: #fff !important;
}
.ytml_info_tabs /deep/.el-tabs__nav-wrap::after{
    background-color: #fff !important;
}
.ytml_info_tabs /deep/.el-tabs__header{
    margin-bottom: 0 !important;
}
.handle {
    cursor: move;
    display: flex;
    align-content: center;
  }
</style>
